import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { FETCH_SERVICE_REQUEST } from '../actions';
import { fetchServiceSuccess, fetchServiceFailure } from './actions';
import { AxiosAPI } from '../../helpers/AxiosAPI';
import { gAPI_Site_Settings } from '../../constants/APIs';

const fetchServiceAPI = async (serviceProvider) => {
    return AxiosAPI({
        method: 'get',
        url: gAPI_Site_Settings,
    })
        .then((res) => {
            const matchedService = res.data.find(
                (item) => item.id.toString() === serviceProvider
            );
            if (matchedService) {
                return { featuresUrl: matchedService?.dashboardUrl };
            } else {
                throw new Error('Service not found');
            }
        })
        .catch((err) => {
            throw err;
        });
};


function* fetchService({ payload: serviceProvider }) {
    try {
        const { featuresUrl } = yield call(fetchServiceAPI, serviceProvider);
        yield put(fetchServiceSuccess(featuresUrl));
    } catch (error) {
        yield put(fetchServiceFailure(error.message));
    }
}


export function* watchFetchService() {
    yield takeEvery(FETCH_SERVICE_REQUEST, fetchService);
}


export default function* serviceSaga() {
    yield all([fork(watchFetchService)]);
}
